import { BaseEditModel } from "model/BaseEditModel";
import Cte from "../cte/Cte";
import MdfeMunicipioDescarga from "./MdfeMunicipioDescarga";

export default class MdfeCte implements BaseEditModel{
    id: number | null;
    key: string | null;
    sequencial: number | null;
    chCte: string;
    segCodBarra: number;
    indReentrega: string;
    cte: Cte | null;
    municipioDescarga: MdfeMunicipioDescarga | null

    constructor(
        id: number | null = null,
        key = "",
        sequencial = 0,
        chCte: string = "",
        segCodBarra: number = 0,
        indReentrega: string = "",
        cte: Cte | null = null,
        municipioDescarga: MdfeMunicipioDescarga | null = null
    ) {
        this.id = id;
        this.key = key;
        this.sequencial = sequencial;
        this.chCte = chCte;
        this.segCodBarra = segCodBarra;
        this.indReentrega = indReentrega;
        this.cte = cte;
        this.municipioDescarga = municipioDescarga;
    }
}